import ConsumerActionButtons from './ConsumerActionButtons';

export default ConsumerActionButtons;
